import { render, staticRenderFns } from "./ClientConfig.vue?vue&type=template&id=595ec417"
import script from "./ClientConfig.vue?vue&type=script&lang=js"
export * from "./ClientConfig.vue?vue&type=script&lang=js"
import style0 from "./ClientConfig.vue?vue&type=style&index=0&id=595ec417&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports